import React, { useEffect, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import CreateBannerForm from "src/features/vendorSponsorshipAdmin/components/CreateBannerForm/CreateBannerForm";
import VENDOR_PROMOTION_FORM from "../../constants/vendorStepsForm";
import { useNavigate, useParams } from "react-router-dom";
import useActivePromotion from "../../hooks/useActivePromotion";
import useEditPromotion from "../../hooks/useEditPromotion";
import CustomToast from "src/components/CustomToast/CustomToast";
import { toast } from "react-toastify";
import adaptEditBanner from "src/features/HomepageCarouselBanners/adapters/adaptEditBanner";
import adaptPromotionForm from "../../adapters/adaptPromotionForm/adaptPromotionForm";

const EditPromotion = () => {
	const navigate = useNavigate();
	const { formId } = useParams<{ formId: number }>();

	const [defaultValues, setDefaultValues] = useState<BannerFormState>({
		bannerStyle: "standard",
		bannerType: "fullScreenTakeoverBanner",
		selectedHashtag: null,
		feedId: null,
		steps: VENDOR_PROMOTION_FORM,
		audienceGroupIds: []
	});

	const { data: banner } = useActivePromotion(formId);

	const { mutate: editForm } = useEditPromotion();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Edited Successfully" />);
		navigate("/vendor-sponsorship/promotion/banners?published=false");
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="There is an error editing the form" />
		);
	};

	const onSubmit: SubmitHandler<BannerFormState> = (data) => {
		console.log("FORM IS VALID, EDIT FORM", { formId, data });

		editForm(adaptEditBanner(formId, data), {
			onSuccess,
			onError
		});
	};

	useEffect(() => {
		console.log({ banner, formId });

		if (formId && banner) {
			console.log("FETCH DEFAULT VALUES", {
				...defaultValues,
				bannerType: banner.template,
				steps: adaptPromotionForm(banner)
			});

			// useActivePromotion returns the raw snake_case CarouselBanner
			// response (not the adapted camelCase Banner shape), so read
			// audience_groups directly off the wire shape.
			// LinkPicker fields — promotions store the link via flat fields
			// rather than the step-array. Read the new wire shape.
			const wire = banner as CarouselBanner & {
				open_in_browser?: boolean;
				feed?: { uuid: string; name: string } | null;
			};
			setDefaultValues((prev) => ({
				...prev,
				bannerType: banner.template,
				steps: adaptPromotionForm(banner),
				buttonLink: banner.button_link ?? "",
				openInBrowser: wire.open_in_browser ?? false,
				linkFeedId: wire.feed?.uuid ?? null,
				selectedLinkFeed: wire.feed
					? { uuid: wire.feed.uuid, name: wire.feed.name }
					: null,
				audienceGroupIds: (banner.audience_groups ?? []).map((g) => g.id)
			}));
		}
	}, [banner, formId]);

	return (
		<CreateBannerForm
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			bannerTypeRadioOptions={["promotionImage", "promotionVideo"]}
			showVariantTab={false}
			showAudienceGroups
			root="promotion"
		/>
	);
};

export default EditPromotion;
